import React from 'react';

import type { ITermsModalData } from 'features/campaigns';

import BaseModal from '../../../../../../../shared/components/BaseModal';

import styles from './TournamentRulesTab.module.css';

interface TermInfoModal {
  modalData: ITermsModalData;
  setModalData: React.Dispatch<React.SetStateAction<ITermsModalData | undefined>>;
}

const TermsInfoModal: React.FC<TermInfoModal> = ({ modalData, setModalData }) => {
  const closeModalIcon = '/ui/menuClose';

  return (
    <BaseModal
      styles={styles as { modalContainer: string; closeModalIcon: string }}
      closeModalIcon={closeModalIcon}
      onClose={() => setModalData((prev) => (prev ? { ...prev, isOpen: false } : prev))}
    >
      <div className={styles['modalContentWrapper']}>
        <span className={styles['modalTitle']}>{modalData.title}</span>
        <div className={styles['termsText']} dangerouslySetInnerHTML={{ __html: modalData.content }} />
      </div>
    </BaseModal>
  );
};
export default TermsInfoModal;
